import { useColorScheme, Box } from '@mui/material';
import {
  allExpanded,
  defaultStyles,
  darkStyles,
  JsonView,
} from 'react-json-view-lite';
import 'react-json-view-lite/dist/index.css';

export const JsonViewer = ({
  data,
}: {
  data: Parameters<typeof JsonView>[0]['data'];
}) => {
  const { mode } = useColorScheme();
  const isDarkMode = mode === 'dark';

  return (
    <Box sx={{ '& > div': { background: 'transparent' } }}>
      <JsonView
        data={data}
        shouldExpandNode={allExpanded}
        style={isDarkMode ? darkStyles : defaultStyles}
      />
    </Box>
  );
};
